import { FC } from 'react';

import { Invoice } from '@ravago/shared/page-data/models/elements';
import { PaginatedResponse } from '@ravago/shared/page-data/models/elements/paginated-response.model';

import { ClosedInvoiceCard } from './closed-invoice-card';

type Props = {
   invoices: { [page: number]: PaginatedResponse<Invoice[]> };
   page: number;
};

export const ClosedInvoiceTableMobile: FC<Props> = ({ invoices, page }) =>
   // eslint-disable-next-line @eslint-react/no-array-index-key
   invoices[page].content.map((invoice, index) => <ClosedInvoiceCard key={index} invoice={invoice} showDivider={index !== 0} />);
